export default "__VITE_ASSET__SMoiRBc5__"